// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.songwriter-summary-view {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}
.songwriter-summary-view .rightsholder-summary-card-wrapper {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.songwriter-summary-view .rightsholder-summary-card-wrapper .info-line > div {
  width: 100%;
  min-width: 0;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/HomeScene/SongwriterSummaryView/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AACF;AACE;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AACJ;AAEM;EACE,WAAA;EACA,YAAA;AAAR","sourcesContent":[".songwriter-summary-view {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 2rem;\n\n  .rightsholder-summary-card-wrapper {\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    .info-line {\n      > div {\n        width: 100%;\n        min-width: 0;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
